import { theme, Typography } from "antd";

export const FormLabel = ({ label }: { label: string }) => {
  const { token } = theme.useToken();
  return (
    <Typography.Text strong style={{ color: token.colorTextSecondary }}>
      {label}
    </Typography.Text>
  );
};
